import React from 'react';

import {
    Link
} from '@material-ui/core';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyContent from '../AuthBodyContent';
import AuthBodyButton from '../AuthBodyButton';

const CONTACT_US_URL = "https://www.landhawk.uk/contact/";

function SendConfirmationInstructionsBody () {
    return (
        <AuthBody>
            <AuthBodyTitle>
                Too many attempts
            </AuthBodyTitle>
            <AuthBodyContent>
                We’ve temporarily locked your account to keep it safe and sent you an email on how to unlock it
                <br />
                <br />
                If you’re having trouble accessing your account please contact our support team at <strong>support@landhawk.uk</strong>
            </AuthBodyContent>
            <Link href={CONTACT_US_URL} target="_blank">
                <AuthBodyButton>
                    Talk to us
                </AuthBodyButton>
            </Link>
        </AuthBody>
    );
}

export default SendConfirmationInstructionsBody;